// extracted by mini-css-extract-plugin
export default {"secondary_btn":"styles_secondary_btn__Uv23H","secondary_btn_md":"styles_secondary_btn_md__Ztw73"};